module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-1ebecd98a3257193e74b61905fa7c69a.webp";